export type PageKeyType = {
  team: RegExp;
  activity: RegExp;
};
export const pageKeyRegex: PageKeyType = {
  team: /\/team(.*)/,
  activity: /\/activity(.*)/,
};
